import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'

import { ReactNode } from 'react'

import { CartProvider } from '@/contexts/CartContext'
import { HeldOrdersProvider } from '@/contexts/HeldOrdersContext'
import { RegisterProvider } from '@/contexts/RegisterContext'
import { SessionProvider } from '@/contexts/SessionContext'

const queryClient = new QueryClient({
  // Most reads and writes go to the device database; the default 'online' mode would pause them while offline.
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1, networkMode: 'offlineFirst' },
    mutations: { networkMode: 'offlineFirst' },
  },
})

/** Provider order matters: the session comes first, the cart needs the register's tax rate, held orders need the cart. */
export const AppProviders = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <SessionProvider>
        <RegisterProvider>
          <CartProvider>
            <HeldOrdersProvider>
              {children}
              <Toaster position="top-center" richColors closeButton duration={2500} />
            </HeldOrdersProvider>
          </CartProvider>
        </RegisterProvider>
      </SessionProvider>
    </BrowserRouter>
  </QueryClientProvider>
)
